import { render, staticRenderFns } from "./AddLiveForm.vue?vue&type=template&id=64867709"
import script from "./AddLiveForm.vue?vue&type=script&lang=js"
export * from "./AddLiveForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports